import "./services-process.css";
import { FaLightbulb, FaPencilRuler, FaCode, FaRocket } from "react-icons/fa";

const processData = [
  {
    step: "01",
    icon: <FaLightbulb />,
    title: "Discovery & Strategy",
    description:
      "We understand your business goals, challenges, and users to define a clear product roadmap.",
  },
  {
    step: "02",
    icon: <FaPencilRuler />,
    title: "Design & Architecture",
    description:
      "UX flows, UI design, and system architecture crafted for performance and scalability.",
  },
  {
    step: "03",
    icon: <FaCode />,
    title: "Development & Testing",
    description:
      "Clean, secure, and scalable development with continuous testing and quality assurance.",
  },
  {
    step: "04",
    icon: <FaRocket />,
    title: "Launch & Growth",
    description:
      "Seamless deployment, monitoring, and long-term support to scale your product confidently.",
  },
];

const ServicesProcess = () => {
  return (
    <section className="services-process">
      <div className="services-process__container">
        {/* HEADER */}
        <div className="services-process__header">
          <span className="services-process__badge">How We Work</span>

          <h2 className="services-process__title">
            From Idea to{" "}
            <span className="services-process__title-accent">
              Scalable Digital Product
            </span>
          </h2>

          <p className="services-process__subtitle">
            Our proven process ensures clarity, speed, and quality at every
            stage — delivering digital solutions built to scale.
          </p>
        </div>

        {/* PROCESS GRID */}
        <div className="services-process__grid">
          {processData.map((item) => (
            <div className="services-process__card" key={item.step}>
              <div className="services-process__step">{item.step}</div>

              <div className="services-process__icon">{item.icon}</div>

              <h3 className="services-process__card-title">{item.title}</h3>

              <p className="services-process__card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesProcess;
